import {
    PageHeader,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableHeader,
    TableRow,
} from '@ksyos/design-system';
import { useNavigate, useParams, useSearchParams } from '@ksyos/router';
import { useEffect, useState } from 'react';
import { PageTemplate } from '@frontend/components/templates/PageTemplate';
import type { IDermaAppLogin } from '../../interfaces/dermaAppLogin';
import { tryParseInt } from '../../../../common/utils/tryParseInt';
import { fetchJson } from '../../../store/fetch';
import { translateKey } from '../../../translate';
import { HeaderGroup, Loader } from '../../elements/common';
import { ListPager } from '../../elements/ListPager';
import { NullableFormattedDatetime } from '../../elements/NullableFormattedDatetime';

export function DermaAppLoginsList() {
    const navigate = useNavigate();
    const { id } = useParams() as { id: string };
    const [searchParams] = useSearchParams();
    const [isSearching, setIsSearching] = useState(true);
    const [total, setTotal] = useState(0);
    const [logins, setLogins] = useState<IDermaAppLogin[]>([]);
    const [currentPage, setCurrentPage] = useState(tryParseInt(searchParams.getOptional('page'), 1));

    useEffect(() => {
        search();
    }, [currentPage]);

    return (
        <PageTemplate width="medium">
            <PageHeader title={translateKey('dermaApp.logins')} />
            <TableContainer>
                <Table spacing="medium">
                    <TableHead>
                        <TableRow>
                            <TableHeader>{translateKey('common.Id')}</TableHeader>
                            <TableHeader>{translateKey('common.dateAdded')}</TableHeader>
                            <TableHeader>{translateKey('common.dateUpdated')}</TableHeader>
                            <TableHeader>{translateKey('dermaApp.expirationDate')}</TableHeader>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!isSearching &&
                            logins.length > 0 &&
                            logins.map((login) => (
                                <TableRow key={login.id}>
                                    <TableCell>{login.id}</TableCell>
                                    <TableCell>
                                        <NullableFormattedDatetime value={login.created_at} />
                                    </TableCell>
                                    <TableCell>
                                        <NullableFormattedDatetime value={login.updated_at} />
                                    </TableCell>
                                    <TableCell>
                                        <NullableFormattedDatetime value={login.expirationDatetime} />
                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {isSearching && <Loader centered />}
            {!isSearching && logins.length === 0 && (
                <HeaderGroup
                    alignment={'center'}
                    header={translateKey('common.noResult')}
                />
            )}
            <ListPager
                isDisabled={isSearching}
                onChangePage={handleNavigation}
                page={currentPage}
                total={total}
            />
        </PageTemplate>
    );

    async function handleNavigation(page: number) {
        navigate(`/dermaAppRegistrations/${id}/logins?page=${page}`);
        setCurrentPage(page);
    }

    async function search() {
        setIsSearching(true);

        const url = `/api/dermaAppRegistrations/${id}/logins?page=${currentPage}`;
        const result = await fetchJson(url, 'GET');

        setTotal(result.json.total);
        setLogins(result.json.items);
        setIsSearching(false);
    }
}
